<template>
  <qtm-content-block v-bind="$attrs" title="Quotes">
    <qtm-content-block v-if="noQuotesReturned" class="mb-6 bg-background">
      No quotes have been returned. As a next step, you may wish to
      <nuxt-link :to="{ name: 'orders-id-invite-suppliers', params: { id: order.id } }">
        invite more suppliers
      </nuxt-link>
      to this request.
    </qtm-content-block>
    <quotes-grid
      :lg="gridLg"
      :md="gridMd"
      :xl="gridXl"
      :order="order"
      :quotes="sortedQuotes"
      :show-actions="showActions"
      @select="activeQuote = $event"
      @update:order="$emit('update:order', $event)"
    />
    <quote-detail-dialog
      v-if="activeQuote"
      v-model:quote="activeQuote"
      model-value
      :order="order"
      :quotes="sortedQuotes"
      :show-actions="showActions"
      @update:model-value="activeQuote = undefined"
      @update:order="$emit('update:order', $event)"
    />
  </qtm-content-block>
</template>

<script setup lang="ts">
import type { Order, Quote } from '@quotetome/materials-api'
import QuoteDetailDialog from '@/components/quotes/quote-detail-dialog.vue'
import QuotesGrid from '@/components/quotes/quotes-grid.vue'
import useQueryParamObject from '@/composables/query-param-object'

export interface Props {
  gridLg?: number
  gridMd?: number
  gridXl?: number
  order: Order
  showActions?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  gridLg: 4,
  gridMd: 6,
  gridXl: 3,
})

defineEmits(['update:order'])

const activeQuote = ref<Quote>()
useQueryParamObject('quote', activeQuote)

const noQuotesReturned = computed(() => !props.order.readyQuotes.length && props.order.waitingForPO)
const sortedQuotes = computed(() => {
  const otherQuotes = props.order.quotes.filter(quote => quote.response_received !== 'price given')
  const readyQuotes = props.order.readyQuotes

  readyQuotes.sort((a, b) => Number(a.total_price || 0) - Number(b.total_price || 0))

  return readyQuotes.concat(otherQuotes)
})

const route = useRoute()

onMounted(() => {
  if (route.query.quote) {
    activeQuote.value = props.order.quotes.find(quote => quote.id === Number(route.query.quote))
  }
})
</script>
